import { theme } from '@prophecy/theme';
import { Display, SlidingPanel, Stack, Text } from '@prophecy/ui-v3';
import { PanelContainer } from '@prophecy/ui-v3/SlidingPanel/styled';
import styled from 'styled-components';

import { BreakdownRows } from './BreakdownRows';
import { CATEGORY_COLOR } from './constants';
import { Dot, SurfaceCard } from './styled';
import { EnvironmentUsageRow } from './types';
import { formatCredits } from './utils';

const PANEL_WIDTH = '400px';

/** SlidingPanel's smallest size is 50%/700px; the design calls for a narrow detail drawer. */
const NarrowPanel = styled(SlidingPanel)`
  width: ${PANEL_WIDTH};
  min-width: ${PANEL_WIDTH};

  ${PanelContainer} {
    min-width: 0;
  }
`;

const TotalCard = styled(SurfaceCard)`
  padding: ${theme.spaces.x12} ${theme.spaces.x16};
`;

export function EnvironmentDetailPanel({
  environment,
  onClose
}: {
  environment: EnvironmentUsageRow;
  onClose: () => void;
}) {
  return (
    <NarrowPanel open size='s' onClose={onClose}>
      <Stack gap={theme.spaces.x20} data-test-id='sap-usage-environment-panel'>
        <Stack gap={theme.spaces.x4}>
          <Text level='lg' weight={theme.fontWeight.medium}>
            {environment.name}
          </Text>
          <Text level='sm' tone={theme.textColor.tertiary}>
            {environment.tenantId} · {formatCredits(environment.dataCredits)} CU TOTAL
          </Text>
        </Stack>

        <TotalCard>
          <Stack gap={theme.spaces.x4}>
            <Text level='sm' weight={theme.fontWeight.medium} tone={CATEGORY_COLOR.data}>
              Data
            </Text>
            <Stack direction='horizontal' gap={theme.spaces.x4} alignY='baseline'>
              <Display level='xs' weight={theme.fontWeight.semiBold}>
                {formatCredits(environment.dataCredits)}
              </Display>
              <Text level='sm' tone={theme.textColor.tertiary}>
                CU
              </Text>
            </Stack>
          </Stack>
        </TotalCard>

        <Stack gap={theme.spaces.x12}>
          <Stack direction='horizontal' gap={theme.spaces.x6} alignY='center'>
            <Dot $color={CATEGORY_COLOR.data} />
            <Text level='sm' weight={theme.fontWeight.medium}>
              Data
            </Text>
            <Text level='sm' tone={theme.textColor.tertiary}>
              {formatCredits(environment.dataCredits)} CU
            </Text>
          </Stack>
          <BreakdownRows rows={environment.dataBreakdown} color={CATEGORY_COLOR.data} />
        </Stack>
      </Stack>
    </NarrowPanel>
  );
}
